module.exports = __webpack_public_path__ + "static/media/heart.2d4847e1.svg";